<template lang="pug">
    .menu
        .menu-button.toggle(v-on:click='menu_visible=!menu_visible')
            .line
            .line
            .line
        .content(v-show='menu_visible')
            .section Sextants:
                span.good {{good_sextants}}
                span /
                span.bad {{bad_sextants}}
            .section Multiselect:
                input(type='checkbox',v-model='multiselect')
            .section
                button(v-on:click='clear_sextants') Clear Sextants
            .section
                button(v-on:click='reset_atlas') Reset Atlas
            .section
                button(v-on:click='help') Help!
                button(v-on:click='commands') Commands
            .section.support-wrapper
                p If you find the site useful, please:
                a(class="bmc-button" target="_blank" href="https://www.buymeacoffee.com/duiker101") Support Me



</template>

<!--.section.support-wrapper-->
<!--.support(v-show='show_support')-->
<!--p If you find this site useful, please consider supporting it by enabling ads.-->
<!--p You may close this menu with the button in the top left.-->
<!--p-->
<!--| Thank you, <br >-->
<!--| Simone-->
<!--#chitikaAdBlock-1-->
<!--iframe(frameborder=0 marginwidth=0 marginheight=0 scrolling=no width=160 height=600 :src="ad_url")-->

<script>
    export default {
        name: "sextants-menu"
        , props: {maps: Object, sextants: Object}
        , data() {
            return {
                menu_visible: true,
                multiselect: false,
                ad_created: false,
                show_support: false
            }
        }
        , watch: {
            sextant: {
                handler() {

                }, deep: true
            }
        }
        , computed: {
            good_sextants() {
                let count = 0;
                for (let s in this.sextants) {
                    if (this.sextants.hasOwnProperty(s)) {
                        let sextant = this.sextants[s];
                        if (sextant.visible && sextant.level < 2)
                            count++;
                    }
                }
                return count;
            }
            // , ad_url() {
            // if (IS_DEV)
            //     return 'http://via.placeholder.com/160x600';
            // return 'http://trglin.com/impression?cid=386854a1ce533d3d82a34c2ac7f9d3b0&did=5&fid=3';
            // }
            , bad_sextants() {
                let count = 0;
                for (let s in this.sextants) {
                    if (this.sextants.hasOwnProperty(s)) {
                        let sextant = this.sextants[s];
                        if (sextant.visible && sextant.level > 1)
                            count++;
                    }
                }
                return count;
            }
        }
        , created() {
            // if (window.CHITIKA === undefined && !IS_DEV) {
            //     let unit = {
            //         "calltype": "async[2]",
            //         "publisher": "duiker101",
            //         "width": 160,
            //         "height": 600,
            //         "sid": "Chitika Default"
            //     };
            //     window.CHITIKA = {'units': [unit]};
            // }
            // setTimeout(()=>{this.show_support = true},2000);
            // this.ad_created=true;
            // let ad = document.createElement('script');
            // ad.setAttribute('src',"//cdn.chitika.net/getads.js");
            // document.head.appendChild(ad);
        }
        , methods: {
            clear_sextants(except_map = null) {
                for (let m in this.maps) {
                    if (this.maps.hasOwnProperty(m)) {
                        let map = this.maps[m];
                        if (except_map === null || map.id !== except_map.id)
                            map.selected = false;
                    }
                }
                this.$parent.calculate_sextants();
            },
            reset_atlas() {
                for (let m in this.maps) {
                    if (this.maps.hasOwnProperty(m)) {
                        let map = this.maps[m];
                        map.selected = false;
                        map.complete = true;
                        map.locked_sextant = 0;
                    }
                }
                this.$parent.calculate_sextants();
                location.hash = '';
            }
            , help() {
                this.$parent.show_sextants();
            }
            , commands() {
                this.$parent.show_commands();
            }
        }
    }
</script>

<style lang="scss" scoped>
    .support-wrapper {
        position: relative;
        width: 160px;
        padding: 10px;
        font-size: 10px;
        text-align: center;
        iframe, .chitikaAdContainer {
            position: absolute;
            top: 0;
            z-index: 11;
        }
        .support {
            padding: 10px;
            position: absolute;
            top: 0;
            z-index: 10;
        }
    }

    .menu-button {
        /*width: 30px;*/
        /*height: 30px;*/
        /*float: left;*/
        /*line-height: 30px;*/
        /*color: gray;*/
        /*font-weight: 700;*/
        /*text-align: center;*/
        /*cursor: pointer;*/

        -webkit-user-select: none; /* webkit (safari, chrome) browsers */
        -moz-user-select: none; /* mozilla browsers */
        -khtml-user-select: none; /* webkit (konqueror) browsers */
        -ms-user-select: none;
    }

    .menu {
        color: white;
        position: absolute;
        top: 0;
        left: 0;
        min-width: 160px;
        background: rgba(0, 0, 0, 0.5);
        box-shadow: 1px 1px 20px 0 rgba(0, 0, 0, 1);
        .toggle {
            cursor: pointer;
            margin: 8px 0;
            .line {
                width: 20px;
                height: 2px;
                margin: 4px;
                display: block;
                background-color: gray;
            }
        }
        .content {
            .section {
                padding: 10px;
            }

            span.good {
                color: rgba(46, 204, 113, 1.0);
                margin: 0 0.5em;
            }
            span.bad {
                color: rgba(231, 76, 60, 1.0);
                margin: 0 0.5em;
            }
        }
    }

    .bmc-button {
        text-decoration: none;
        display: inline-block;
        padding: 0px 10px;
        color: #000;
        background-color: #FFFFFF;
        border-radius: 3px;
        border: 1px solid transparent;
        font-size: 1.5em;
        box-shadow: 0px 1px 2px rgba(190, 190, 190, 0.5);
        -webkit-box-shadow: 0px 1px 2px 2px rgba(190, 190, 190, 0.5);
        -webkit-transition: 0.3s all linear;
        transition: 0.3s all linear;
        margin: 0 auto;
        line-height: 30px;
        img {
            height: 30px;
            box-shadow: none;
            border: none;
            vertical-align: middle;
        }
    }

    .bmc-button:hover, .bmc-button:active, .bmc-button:focus {
        -webkit-box-shadow: 0 4px 16px 0 rgba(190, 190, 190, .45);
        text-decoration: none;
        box-shadow: 0 4px 16px 0 rgba(190, 190, 190, .45);
        opacity: 0.85;
    }
</style>


// WEBPACK FOOTER //
// src/components/SextantsMenu.vue